import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup;
  submitted: boolean;

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.contactForm = this.fb.group({
      name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
      email: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
      phone: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      message: ["", Validators.required],
    });
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }
    return true;
  }

  get con(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }
    const data = {
      name: this.contactForm?.value?.name,
      email: this.contactForm?.value?.email,
      phone: this.contactForm?.value?.phone,
      message: this.contactForm?.value?.message,
    };

    // this.spinner.show();

    // // Make the API call with the constructed data object
    // this.apiCall.contactUsForm(data).subscribe({
    //   next: (response) => {
    //     this.spinner.hide();
    //     if (response.success) {
    //       this.common.showMessage("success", response.message);
    //       this.contactForm.reset();
    //       this.submitted = false;
    //     } else {
    //       this.common.showMessage("error", response.message);
    //     }
    //   },
    //   error: (error: any) => {
    //     this.spinner.hide();
    //     this.common.showMessage("error", error?.message);
    //   },
    // });
  }

}
